import { Fragment } from 'react';

import { SEARCH_SPLIT_REGEX } from '~/components/DropdownTreeSingleSelect/constants';
import type { InternalDropdownOption } from '~/components/DropdownTreeSingleSelect/types';

export function DropdownItemLabel({
  option,
  searchQuery,
}: {
  option: InternalDropdownOption;
  searchQuery?: string;
}) {
  const optionLabel = option.label || option.value;

  if (!searchQuery) {
    return optionLabel;
  }

  const searchTerms = searchQuery.toLowerCase().split(SEARCH_SPLIT_REGEX);
  const optionSplit = optionLabel.split(SEARCH_SPLIT_REGEX);
  const optionMatches = optionLabel.match(SEARCH_SPLIT_REGEX);

  return (
    <span className="text-emphasis-stronger">
      {optionSplit.map((word, index) => {
        const match = searchTerms.find(
          (term) => term && word.toLowerCase().startsWith(term),
        );

        if (match) {
          return (
            <Fragment key={index}>
              <span
                role="mark"
                className="underline decoration-2 underline-offset-4 bg-emphasis-subtle text-default decoration-emphasis-stronger"
              >
                {word.slice(0, match.length)}
              </span>
              {word.slice(match.length)}
              {optionMatches?.[index]}
            </Fragment>
          );
        }

        return (
          <Fragment key={index}>
            {word}
            {optionMatches?.[index]}
          </Fragment>
        );
      })}
    </span>
  );
}

DropdownItemLabel.displayName = 'DropdownItemLabel';
